import * as React from 'react';

import { get } from 'lodash-es';

import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

export default function ComboBox({
  field = {},
  form: { touched, errors, setFieldTouched } = {},
  options = [],
  labelStyle = {},
  required = false,
  label = '',
  multiple = true,
  ...rest
}) {
  return (
    <Autocomplete
      value={field?.value}
      multiple={multiple}
      data-test-id='tags-outlined'
      size='small'
      options={options}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      getOptionLabel={(option) => {
        return option.value;
      }}
      filterSelectedOptions
      onBlur={() => setFieldTouched(field?.name, true, true)}
      renderInput={(params) => (
        <TextField
          {...labelStyle}
          {...params}
          label={label}
          required={required}
          error={Boolean(get(touched, field?.name) && get(errors, field?.name))}
          helperText={get(touched, field?.name) && get(errors, field?.name)}
          FormHelperTextProps={{ ['data-test-id']: field?.name }}
        />
      )}
      {...rest}
    />
  );
}
